import { render, staticRenderFns } from "./userCenterDetail.vue?vue&type=template&id=6c158f9e&scoped=true&"
import script from "./userCenterDetail.vue?vue&type=script&lang=js&"
export * from "./userCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./userCenterDetail.vue?vue&type=style&index=0&id=6c158f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c158f9e",
  null
  
)

export default component.exports